import React, { useContext } from 'react';
import { List, ListItem } from '@mui/joy';
import { RouterAnchor as Anchor } from "../RouterAnchor"
import { AppContext, SettingsContext } from '../../../mtska-frontend-app-scaffolding';

import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/mtska-frontend-app-component/assets';


const ModuleMenu = ({ }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const { currentModuleNavigationData, userCapabilities, appConfiguration } = useContext(AppContext);
    const { filterByLegalEntity, settings } = useContext(SettingsContext)

    console.info('ModuleMenu', 'appConfiguration?.legalEntitySelector?.active', appConfiguration?.legalEntitySelector?.active);
    console.info('ModuleMenu', 'currentModuleNavigationData', currentModuleNavigationData);
    console.info('ModuleMenu', 'userCapabilities', userCapabilities);

    return (
        <nav className="module-menu">
            {
                /**
                 * NON HO CAPITO PERCHÈ FACCIAMO FILTRO SU LEGALENTITY SELECTOR. Per ora commento, cancellare tutto se ok
                 */
            }
            {/* {((appConfiguration?.legalEntitySelector?.active && settings && filterByLegalEntity) || !appConfiguration?.legalEntitySelector?.active) && ( */}
                <List className="module-menu-portion module-menu-portion-activities">
                    {currentModuleNavigationData && Object.entries(currentModuleNavigationData).map(([k, moduleMenuItem]) => {
                        // console.info('----')
                        // console.info('ModuleMenu', moduleMenuItem ?? '',  userCapabilities ?? '', moduleMenuItem?.capability ?? '', userCapabilities[moduleMenuItem.capability] ?? 'Manca '+moduleMenuItem.capability+' in userCapabilities');
                        // console.info('Model printing condition?', 'c1', moduleMenuItem,'c2',  userCapabilities, 'c3', userCapabilities[moduleMenuItem.capability], 'c4', moduleMenuItem.moduleMenuVisibility);
                        // console.info('Model is printed?', moduleMenuItem && userCapabilities && userCapabilities[moduleMenuItem.capability] && moduleMenuItem.moduleMenuVisibility)
                        return (moduleMenuItem && userCapabilities && userCapabilities[moduleMenuItem.capability] && moduleMenuItem.moduleMenuVisibility) && (
                            <ListItem
                                key={k}
                                className={moduleMenuItem.href.split('?')[0] === location.pathname.split('?')[0] ? "module-menu-item module-menu-item-selected" : "module-menu-item"}
                            >
                                <Anchor underline="none" className="label" href={moduleMenuItem.href}>
                                    {moduleMenuItem.icon && <Icon icon={moduleMenuItem.icon} className="icon" />}
                                    {t(moduleMenuItem.title)}
                                </Anchor>
                            </ListItem>
                        )
                    })}
                </List>
            {/* )} */}
        </nav>
    );
};

export default ModuleMenu;
